import actions from './actions';
import getters from './getters';
import mutations from './mutations';
var state = () => ({
  total: null,
  products: null,
  suggestions: null,
  description: null,
  provider: null
});
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};